// extracted by mini-css-extract-plugin
module.exports = {"containerNewEditor":"EditorOnePage_containerNewEditor__3WGq_","newEditor":"EditorOnePage_newEditor__XyBoQ","transformComponent":"EditorOnePage_transformComponent__336Bk"};